<template>
  <div class="SForm">
    <el-form
      :inline="inline"
      ref="dataForm"
      :model="dataForm"
      :rules="rules"
      :label-position="labelPosition"
      :label-width="labelWidth"
    >
      <el-form-item
        v-for="(item, index) in fields"
        v-bind:key="index"
        :label="item.label"
        :prop="item.prop"
        :rules="item.rules"
        v-show="!item.isHide"
        :style="formStyle"
      >
        <el-select
          v-if="item.type === 'select'"
          filterable
          v-model="dataForm[item.prop]"
          :placeholder="item.placeholder"
        >
          <el-option
            v-for="(option, index) in item.data"
            v-bind:key="index"
            :label="option.label"
            :value="option.value"
          ></el-option>
        </el-select>

        <el-radio-group
          v-else-if="item.type === 'radio'"
          v-model="dataForm[item.prop]"
        >
          <el-radio
            v-for="(option, index) in item.data"
            :label="option.value"
            v-bind:key="index"
            >{{ option.label }}</el-radio
          >
        </el-radio-group>

        <el-switch
          v-else-if="item.type === 'switch'"
          v-model="dataForm[item.prop]"
          :placeholder="item.placeholder"
        ></el-switch>

        <el-date-picker
          v-else-if="item.type === 'date'"
          :type="item.option.type"
          v-model="dataForm[item.prop]"
          :placeholder="item.placeholder"
        ></el-date-picker>

        <el-transfer
          v-else-if="item.type === 'transfer'"
          :titles="[item.title1, item.title2]"
          filterable
          filter-placeholder="请输入搜索内容"
          v-model="dataForm[item.prop]"
          :data="data"
        ></el-transfer>

        <el-input
          v-else-if="item.type === 'textarea'"
          v-model="dataForm[item.prop]"
          :placeholder="item.placeholder"
          :autosize="{ minRows: 1, maxRows: 50 }"
        ></el-input>
        <cn-region-picker
          v-else-if="item.type === 'pickCity'"
          v-model="dataForm[item.prop]"
          :placeholder="item.placeholder"
        ></cn-region-picker>

        <el-input
          v-else-if="item.type === 'password'"
          v-model="dataForm[item.prop]"
          :placeholder="item.placeholder"
          show-password
          readonly
          @focus="addFocus"
        ></el-input>
        <el-input
          v-else-if="item.type === 'percent'"
          v-model="dataForm[item.prop]"
          :placeholder="item.placeholder"
          type="number"
          :step="item.step ? item.step : 1"
          :min="item.min ? item.min : 0"
          :max="item.max ? item.max : 100"
          >%</el-input
        >
        <el-input
          v-else-if="item.type === 'number'"
          v-model="dataForm[item.prop]"
          :placeholder="item.placeholder"
          type="number"
        ></el-input>
        <el-input
          v-else-if="item.type === 'query'"
          v-model="dataForm[item.prop]"
          :placeholder="item.placeholder"
          :disabled="item.disabled"
          @blur="queryData"
        ></el-input>
        <STree
          v-else-if="item.type === 'tree'"
          v-model="dataForm[item.prop]"
          :data="item.option.data"
        ></STree>

        <el-tree
          v-else-if="item.type === 'unTree'"
          :data="item.option.data"
          :props="item.defaultProps"
          style="width: 200px; margin-left: 100px; margin-top: 10px"
        ></el-tree>

        <SCity
          v-else-if="item.type === 'city'"
          v-model="dataForm[item.prop]"
        ></SCity>

        <el-image
          v-else-if="item.type === 'image'"
          style="margin-left: 100px; width: 100px; height: 100px"
          :src="item.imageSrc"
          fit="fill"
        ></el-image>

        <el-cascader
          v-else-if="item.type === 'cascaderCity'"
          :options="item.options"
          v-model="dataForm[item.prop]"
          :placeholder="item.placeholder"
          :props="item.props"
          :ref="item.ref"
        ></el-cascader>

        <el-cascader
          v-else-if="item.type === 'cascadersingle'"
          :options="item.options"
          v-model="dataForm[item.prop]"
          :placeholder="item.placeholder"
          :props="item.props"
          :ref="item.ref"
          clearable
          filterable
          @change="handleChange"
        ></el-cascader>

        <div
          v-else-if="item.type === 'div'"
          style="margin-left: 80px; width: 400px"
        >
          {{ dataForm[item.prop] || "--" }}
        </div>

        <el-input
          v-else
          v-model="dataForm[item.prop]"
          :placeholder="item.placeholder"
          :disabled="item.disabled"
        ></el-input>
      </el-form-item>
      <div class="btns" v-if="isShowBtn">
        <el-form-item>
          <el-button @click="cancel" class="resetbtn">取消</el-button>
          <el-button type="success" @click="save">保存</el-button>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "SForm",
  props: {
    inline: {
      type: Boolean,
      default() {
        return true;
      }
    },
    formStyle: {
      type: String
    },
    url: {
      type: String
    },
    imageSrc: {
      type: String
    },
    dataForm: {
      type: Object,
      default: () => {}
    },
    method: {
      type: String,
      default() {
        return "put";
      }
    },
    labelWidth: {
      type: String,
      default() {
        return "80px";
      }
    },
    labelPosition: {
      type: String,
      default() {
        return "right";
      }
    },
    fields: {
      type: Array,
      default() {
        return [];
      }
    },
    isShowBtn: {
      type: Boolean,
      default() {
        return true;
      }
    },
    before: {
      type: Function
    },
    handle: {
      type: Function
    },
    itemStyle: {
      type: String,
      default() {
        return "display:block;";
      }
    }
  },
  data() {
    return {
      rules: {},
      defaultProps: {
        children: "children",
        label: "label"
      }
    };
  },
  created: function() {
    const { fields } = this;
    for (let i = 0; i < fields.length; i++) {
      const field = fields[i];
      //设置默认选中项
      if (field.type == "select" && field.defaultValue != "") {
        this.$set(this.dataForm, field.prop, field.defaultValue);
      }
      if (field.rules && field.rules.length > 0) {
        this.rules[field.prop] = field.rules;
      }
    }
  },
  computed: {},
  watch: {},
  methods: {
    handleChange(value) {
      // console.log(value);
    },
    save() {
      const o = this;
      const { url, method, before, handle } = this;
      const dataForm = this.dataForm;
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          let data = dataForm;
          if (before) data = before(dataForm);
          if (data == false) {
            return false;
          }
          if (url) {
            this.$store.dispatch("form/handle", {
              url: url,
              data: data,
              method: method,
              callback: function(resp) {
                handle(resp, o);
              }
            });
          } else {
            if (handle) handle(data, o);
          }
        } else {
          return false;
        }
      });
    },
    queryData() {
      this.$emit("queryInputData");
    },
    cancel() {
      this.$router.go(-1);
    },
    addFocus(e) {
      e.target.removeAttribute("readonly");
    }
  }
};
</script>

<style scoped lang="less">
@import "./index.less";
</style>
<style></style>



// WEBPACK FOOTER //
// src/components/SForm/index.vue